import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/poshmark-packaging';

export default function Example() {
  return (
    <>
      <Head>
        <title>Poshmark Packaging Ideas </title>
        <meta
          name='description'
          content='Poshmark is a clothing and accessory trading site that lets you buy and sell clothes, shoes, handbags, and other accessories. One of the main things to remember when packing sold items on Poshmark is to package them safely so they will not be damaged while in transit. '
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/poshmark-packaging' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/poshmark-packaging' />
        <meta property='og:title' content='Poshmark Packaging Ideas ' />
        <meta
          property='og:description'
          content='Poshmark is a clothing and accessory trading site that lets you buy and sell clothes, shoes, handbags, and other accessories. One of the main things to remember when packing sold items on Poshmark is to package them safely so they will not be damaged while in transit. '
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:modified_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:tag' content='Poshmark' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
